
export const solutions = {
  '1gb.solutions': 'Soluzioni 1Gb',
  '10gb.solutions': 'Soluzioni 10Gb',
  '1gb.vpx.accessories': 'Accessori VPX 1Gb',
  'software': 'Software',
  '1gb.description': 'Soluzioni AV su IP 1Gb ad alte prestazioni',
  '10gb.description': 'Soluzioni AV su IP 10Gb ultra-performanti',
  'vpx.accessories.description': 'Accessori essenziali per soluzioni VPX 1Gb',
  'software.description': 'Il software Aurora IPBaseT Manager è un\'applicazione di controllo all-in-one per i prodotti IPX, VPX e VLX di Aurora IPBaseT AV su IP',
  'avoip.solutions': 'Soluzioni AVOIP',
  'choose.network.speed': 'Scegli la tua velocità di rete preferita',
  'touch.controllers': 'Touch Controller',
  'touch.controllers.description': 'Interfacce touch panel professionali per un controllo senza interruzioni',
  'control.processors': 'Processori di controllo',
  'control.processors.description': 'Processori di controllo avanzati per la gestione del sistema',
  'reax.software': 'Software',
  'reax.software.description': 'Software professionale per lo sviluppo di sistemi di controllo',
  'reax.accessories': 'Accessori',
  'reax.accessories.description': 'Accessori essenziali per i sistemi ReAX',
  'reax.control.solutions': 'Soluzioni di controllo ReAX',
  'choose.control.solution': 'Scegli la tua soluzione di controllo preferita',
  'digital.signal.processors': 'Processori di segnale digitale',
  'dsps.description': 'Soluzioni professionali di elaborazione audio',
  'amplifiers': 'Amplificatori',
  'amplifiers.description': 'Amplificazione audio ad alte prestazioni',
  'speakers': 'Altoparlanti',
  'speakers.description': 'Soluzioni di riproduzione audio premium',
  'audio.solutions': 'Soluzioni audio',
  'choose.audio.solution': 'Scegli la tua soluzione audio preferita',
};
